@let collapsedOpen = collapsedOpen$ | async;
@let logo = logoUrl$ | async;
@let username = userName$ | async;
@let isDesktop = isDesktop$ | async;

<!-- TODO: wire (mouseenter)="collapseOpenSidenav()" / (mouseleave)="collapseCloseSidenav()" below to
     make the collapsed rail expand on hover. The service state and the `.collapsed.open` styles are
     both in place; only the triggers are missing. -->
<div
  [class.collapsed]="collapsed"
  [class.open]="collapsed && collapsedOpen"
  class="rms-sidenav flex flex-col">
  <div class="rms-sidenav-toolbar__container">
    <div class="sidenav-toolbar flex-none flex items-start">
      <img
        alt="Logo"
        class="select-none flex-none my-1"
        [src]="logo" />
    </div>
  </div>

  <rms-scrollbar class="flex-1 flex flex-col">
    <div class="pt-5 flex-1">
      @for (item of items$ | async; track trackByRoute($index, item)) {
        <rms-sidenav-item
          [item]="item"
          [level]="0"
          [showTooltip]="collapsed" />
      }
    </div>
  </rms-scrollbar>

  @if (isDesktop) {
    <div class="ml-2 p-2">
      @if (collapsed) {
        <button
          (click)="toggleCollapse()"
          class="rms-sidenav-toolbar__collapse-toggle"
          type="button">
          <mat-icon
            [matTooltip]="'layout.expand' | translate"
            matTooltipPosition="right"
            svgIcon="remix:Arrows/expand-right-line" />
        </button>
      } @else {
        <button
          (click)="toggleCollapse()"
          class="rms-sidenav-toolbar__collapse-toggle"
          type="button">
          <mat-icon svgIcon="remix:Arrows/expand-left-line" />
          <span
            class="pl-3"
            translate
            >layout.collapse</span
          >
        </button>
      }
    </div>
  }

  @if (userVisible) {
    <div class="rms-sidenav-user__container flex-none">
      <div
        class="rms-sidenav-user flex items-center"
        [matMenuTriggerFor]="userMenu"
        matRipple
        matRippleColor="var(--rms-sidenav-item-ripple-color)">
        <span class="rms-sidenav-user__image text-center bg-caeruleus p-2">
          {{ username | userInitials }}
        </span>
        <div class="rms-sidenav-user__content flex-auto">
          <div class="rms-sidenav-user__title">{{ username }}</div>
          <div class="rms-sidenav-user__subtitle"></div>
        </div>
        <mat-icon
          class="rms-sidenav-user__dropdown-icon flex-none"
          svgIcon="mat:arrow_drop_down" />
      </div>
    </div>
  }

  <mat-menu
    #userMenu="matMenu"
    yPosition="above"
    [overlapTrigger]="false"
    [hasBackdrop]="true"
    class="w-52 sidenav-user-menu">
    <a
      mat-menu-item
      routerLink="/profile">
      <mat-icon svgIcon="remix:User & Faces/account-circle-line" />
      <span translate>layout.user-menu.profile</span>
    </a>
    <a
      mat-menu-item
      target="_blank"
      href="https://help.romulus.live">
      <mat-icon svgIcon="remix:Business/customer-service-line" />
      <span translate>layout.user-menu.help</span>
    </a>

    <button
      mat-menu-item
      (click)="logout()">
      <mat-icon svgIcon="remix:System/logout-box-line" />
      <span translate>layout.user-menu.logout</span>
    </button>
  </mat-menu>
</div>
